import { render, staticRenderFns } from "./DevicesSettings.vue?vue&type=template&id=2e50f9b6"
import script from "./DevicesSettings.vue?vue&type=script&lang=js"
export * from "./DevicesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports